"use client";

import { motion } from "framer-motion";
import { useEffect } from "react";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-20"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-white p-8 shadow-lg md:p-12">
          <h1 className="mb-8 text-center text-4xl font-bold text-gray-900">
            Privacy Policy
          </h1>

          <div className="prose prose-lg max-w-none leading-relaxed text-gray-700">
            <p className="mb-6 text-lg">
              Nautilus Times is committed to maintaining the confidentiality,
              integrity, and security of data acquired through its maritime
              information services and digital interfaces. By accessing or
              utilizing our website and associated services, users consent to
              the practices delineated herein.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              1. Information Acquisition
            </h2>
            <p className="mb-4">
              We may collect, process, and archive the following categories of
              information:
            </p>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                <strong>Voluntary Disclosures:</strong> Information you provide
                during account creation, subscription, or communication.
              </li>
              <li>
                <strong>Automated Data Capture:</strong> Metadata, IP addresses,
                geolocation traces, device identifiers, and browser fingerprints
                generated during site interaction.
              </li>
              <li>
                <strong>Transactional Records:</strong> Payment confirmations,
                digital receipts, and service usage logs associated with your
                engagement.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              2. Utilization of Data
            </h2>
            <p className="mb-4">Collected information may be employed for:</p>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Facilitating access to subscription services and maritime
                insights.
              </li>
              <li>
                Ensuring operational continuity, fraud mitigation, and system
                security.
              </li>
              <li>
                Compliance with maritime regulatory frameworks and allied
                statutory requirements.
              </li>
              <li>
                Analytical, archival, and research-driven evaluations intended
                to enhance service quality.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              3. Data Dissemination & Third-Party Access
            </h2>
            <p className="mb-4">
              Information shall not be sold, leased, or bartered. However, it
              may be:
            </p>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Shared with authorized service providers engaged in hosting,
                payment processing, analytics, or technical facilitation.
              </li>
              <li>
                Disclosed in compliance with legal obligations or regulatory
                directives, particularly those applicable to maritime commerce.
              </li>
              <li>
                Transferred during corporate restructuring, mergers, or
                acquisitions, subject to equivalent safeguards.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              4. Data Retention & Security
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Information will be retained only for the duration necessary to
                fulfill contractual or regulatory obligations.
              </li>
              <li>
                Multiple safeguards, including encryption, controlled access,
                and network monitoring, are deployed to mitigate unauthorized
                intrusion.
              </li>
              <li>
                Notwithstanding these measures, absolute immunity from breaches
                cannot be guaranteed, and users acknowledge such inherent
                digital risks.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              5. User Rights & Limitations
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                You may request access, rectification, or restricted usage of
                your data by contacting us.
              </li>
              <li>
                Nautilus Times retains overriding discretion to limit or deny
                requests if compliance would undermine maritime operational
                integrity, security protocols, or legal mandates.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              6. Policy Amendments
            </h2>
            <p className="mb-6">
              This Privacy Policy may be updated periodically to reflect legal,
              technical, or operational changes. Continued use of our services
              constitutes binding acceptance of such modifications.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Privacy;
